/* ---------------------------------------------------------------------
   Category PLP — sections/main-plp.liquid

   Five small jobs, all of them progressive enhancement: every one of the
   elements below already works, or already leads somewhere, with this file
   absent.

     1. banner carousel   (Swiper, loaded globally in layout/theme.liquid)
     2. back button       a link to the parent category, upgraded to a real
                          "back" when there is history to go back to
     3. sub-category rail scrolls the category you're on into view, since
                          it is often past the right edge on a phone
     4. all-filters sheet the pinned filter icon opens it; the pills in the
                          bar keep their own single-group panels
     5. empty notice      a line, on a category nothing is tagged into yet

   The pills, their panels and the applied-filter chips are the theme's
   existing filter bar (assets/custom.js) — nothing here touches them.
--------------------------------------------------------------------- */
(function () {
  'use strict';

  /* ---- 1. banner carousel ---- */
  function initBanner() {
    var el = document.querySelector('[data-plp-banner]');
    if (!el || el.swiper) return false;
    if (typeof window.Swiper === 'undefined') return false;

    var slides = el.querySelectorAll('.swiper-slide').length;

    new window.Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      loop: slides > 1,
      pagination: slides > 1
        ? { el: el.querySelector('[data-plp-banner-dots]'), clickable: true }
        : false,
      autoplay: slides > 1 ? { delay: 4000, disableOnInteraction: false } : false,
      observer: true,
      observeParents: true
    });

    return true;
  }

  /* Swiper is deferred, so it may not be parsed yet when this runs. Give
     it a bounded number of tries rather than an open-ended interval. */
  function waitForSwiper(attempts) {
    if (initBanner()) return;
    if (attempts <= 0) return;
    setTimeout(function () { waitForSwiper(attempts - 1); }, 100);
  }

  /* ---- 2. back button ---- */
  function initBack() {
    var back = document.querySelector('[data-plp-back]');
    if (!back) return;

    back.addEventListener('click', function (e) {
      /* Only when there is somewhere to go back to WITHIN this site —
         otherwise the href (the parent category) is the better answer,
         and a shopper who landed here from a search result isn't sent
         back out to the search engine. */
      if (window.history.length > 1 && document.referrer.indexOf(window.location.origin) === 0) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  /* ---- 3. sub-category rail ---- */
  function initRail() {
    /* Every rail on the page, not just the first: Fashion & Lifestyle
       runs three of them (Category, Occasion, Price) and an applied
       filter marks its bubble current in whichever one it belongs to. */
    var rails = document.querySelectorAll('.plp-subrail');
    for (var i = 0; i < rails.length; i++) {
      var rail = rails[i];
      var current = rail.querySelector('.plp-subrail-item.is-current');
      if (!current) continue;
      if (rail.scrollWidth <= rail.clientWidth) continue;

      /* Centred rather than scrollIntoView's edge-alignment, and set
         directly on the rail so the page itself doesn't jump. */
      rail.scrollLeft = current.offsetLeft - (rail.clientWidth - current.offsetWidth) / 2;
    }
  }

  /* ---- 4. all-filters sheet ---- */
  function initSheet() {
    var sheet = document.querySelector('[data-plp-sheet]');
    if (!sheet) return;

    function open() {
      sheet.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      sheet.hidden = true;
      document.body.style.overflow = '';
    }

    /* Two ways in: the pinned icon in the bar, whose "all" pill has no
       panel of its own (snippets/collection-filters.liquid), and "See all"
       beside the Shop-by row, which is asking for the same thing. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.plp-filterbar [data-filter-pill="all"]') ||
          e.target.closest('[data-plp-sheet-open]')) {
        e.preventDefault();
        open();
        return;
      }
      if (!sheet.hidden && e.target.closest('[data-plp-sheet-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  /* ---- 5. empty-category notice ---- */
  function initToast() {
    var toast = document.querySelector('[data-plp-toast]');
    if (!toast) return;

    /* Rendered only when the category really is empty, so its presence is
       the condition. Shown a beat late so it reads as a message rather
       than as part of the page, and taken away on its own — the empty
       state in the grid is the version that stays. */
    setTimeout(function () {
      toast.hidden = false;
      /* The class has to land in a later style resolution than the unhide
         or there is nothing to transition from. A forced reflow is what
         guarantees that; requestAnimationFrame is not scheduled at all in
         a backgrounded tab, which would leave the toast unhidden at zero
         opacity — present, and invisible. */
      void toast.offsetWidth;
      toast.classList.add('is-visible');
    }, 400);

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 5000);
  }

  function init() {
    waitForSwiper(50);
    initBack();
    initRail();
    initSheet();
    initToast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.plp')) init();
  });
})();
